// Hand-drawn star - imperfect, sketchy
export function DoodleStar({
  size = 20,
  color = 'rgba(255, 226, 188, 0.6)',
  className = '',
  style = {}
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      style={style}
    >
      {/* Hand-drawn 4-point star */}
      <path
        d="M 12 2 L 12.5 11.5 L 12 11.8 M 12 11.8 L 2.5 12 L 11.7 12.3 M 11.7 12.3 L 12 22 L 12.2 12.5 M 12.2 12.5 L 21.5 12.2 L 12.3 11.9 M 12.3 11.9 L 12 2"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
